/* HolyH₂O custom.js (fixed 22 Oct 2026)
   1. Desktop dropdown menus open on hover.
   2. The ✕ in the mobile menu closes it the same way the hamburger does,
      so the grey backdrop and the scroll lock are removed properly. */

$("header-menu details").each(function () {
  $(this).mouseover(function () {
    $(this).attr("open", "");
    $(this).children("summary").attr("aria-expanded", "true");
  })
  .mouseout(function () {
    $(this).removeAttr("open");
    $(this).children("summary").attr("aria-expanded", "false");
  });
});

$(".colseBtn").on("click", function (e) {
  e.preventDefault();
  var drawer = document.getElementById("Details-menu-drawer-container");
  var toggle = drawer ? drawer.querySelector("summary") : null;
  if (drawer && drawer.open && toggle) {
    toggle.click();
  }
});